// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p67sn","text-centered":"styles_text-centered__f-v8f"};